import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {SimpleGrid} from '@chakra-ui/react'
import TeaserLink from '../../../components/teaser-link'
import {normalizeSfccLink} from '../../../utils/url'

const CSTeaserLinks = ({links}) => {
    const {locale} = useIntl()

    const normalizedLinks = useMemo(
        () =>
            links?.map(({link, label, icon}) => ({
                label,
                icon,
                href: normalizeSfccLink(locale, link)
            })) ?? [],
        [links, locale]
    )

    return (
        <SimpleGrid
            columns={{base: 1, lg: 2}}
            gap={{base: 4, lg: 8}}
            data-testid="cs-teaser-links"
            w="100%"
        >
            {normalizedLinks.map((subpage, idx) => (
                <TeaserLink key={idx} to={subpage.href} title={subpage.label} />
            ))}
        </SimpleGrid>
    )
}

CSTeaserLinks.propTypes = {
    links: PropTypes.array
}

export default CSTeaserLinks
